import NamedDto from 'modules/base/dto/NamedDto';

export class OptimizationPipelinePiMeasurementEntryDto extends NamedDto {
    constructor() {
        super();

        /** @type {number} */
        this.piMeasurementReader = null;

        /** @type {number} */
        this.measurement = null;
    }

    /**
     * @typedef {Object} _OptimizationPipelinePiMeasurementEntryDtoProps
     * @property {number} piMeasurementReader
     * @property {number} measurement
     *
     * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizationPipelinePiMeasurementEntryDtoProps} OptimizationPipelinePiMeasurementEntryDtoProps
     */

    /**
     *
     * @param {OptimizationPipelinePiMeasurementEntryDtoProps} props
     * @returns {OptimizationPipelinePiMeasurementEntryDto}
     */
    setup(props) {
        super.setup(props);

        this.piMeasurementReader = props.piMeasurementReader;
        this.measurement = props.measurement;

        return this;
    }
}

export default OptimizationPipelinePiMeasurementEntryDto;